export const DOMAIN = 'auth.user.customers';
